import React from 'react';

const File = props => {
  const {
    className,
    id,
    onChange,
    labelLocale,
    disabled,
    accept
  } = props;
  const dataPath = props["data-path"];
  let acceptAttribute = null;
  if(accept) {
    acceptAttribute = accept
  }
  return (
    <div className={"custom-input custom-input-file" + (className ? " " + className : "") }>
      {labelLocale && (<label>{labelLocale}</label>)}
      <input 
        id={id}
        data-path={dataPath}
        type="file"
        onChange={onChange}
        disabled={disabled}
        accept={acceptAttribute}
      />
    </div>
  );
};

export default File;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/file.jsx